module.exports = __webpack_public_path__ + "static/media/feather1.9dbf80ad.png";